import React from 'react';
import { Container, Row, Col } from "react-bootstrap";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faComputerMouse } from '@fortawesome/free-solid-svg-icons';
import './styles/action-list-empty.css';

interface ActionListEmptyProps {
  sdg: number | undefined;
}

const ActionListEmpty: React.FC<ActionListEmptyProps> = ({ sdg }) => {
  return (
    <Container className="action-empty-container">
      <Row>
        <Col className="d-flex justify-content-center">
          <section className="action-empty-card">
            <header className="action-empty-header">
              <p className="action-empty-kicker">No actions created yet</p>
              <h3 className="action-empty-title">
                Start building your action list
              </h3>
              <p className="action-empty-subtitle">
                Create a set of actions you can share with your supply chain, client,
                or wider stakeholder community.
              </p>
            </header>

            <div className="action-empty-body">
              <p className="action-empty-description">
                This helps you show how your event will advance progress towards
                Sustainable Development Goal {sdg ?? '…'}.
              </p>

              <ul className="action-empty-list">
                <li>
                  <FontAwesomeIcon icon={faComputerMouse} className="action-empty-icon" />
                  <span>
                    Press <strong>Generate Actions</strong> to get new, creative ideas
                    based on best practice.
                  </span>
                </li>
                <li>
                  <FontAwesomeIcon icon={faComputerMouse} className="action-empty-icon" />
                  <span>
                    Press <strong>Add My Action</strong> to include your own ideas and
                    commitments.
                  </span>
                </li>
              </ul>
            </div>
          </section>
        </Col>
      </Row>
    </Container>
  );
};

export { ActionListEmpty };
